<template>
  <div
    class="d-flex justify-content-center"
    :class="{ loading: loading, disabled: disabled }"
  >
    <button
      :disabled="loading || disabled"
      @click="handleClick"
      class="app-btn"
      :class="isSecondary ? 'secondary' : ''"
      :id="id"
    >
      <span v-if="loading">
        <i class="fas fa-spinner fa-spin"></i>
      </span>
      <slot v-else>{{ buttonText }}</slot>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    text: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    clickHandler: {
      type: Function as PropType<(e: MouseEvent) => void>,
      required: true,
      default: (): void => undefined,
    },
  },
  setup(props) {
    return {
      isLoading: props.loading,
      buttonText: props.text,
      isSecondary: props.secondary,
      isDisabled: props.disabled,
    };
  },
  methods: {
    handleClick(e: MouseEvent): void {
      this.clickHandler(e);
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/apps/credit-line/styles/index";
.app-btn {
  background: $pj-color-green;
  border-radius: 11px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.8px;
  color: $pj-color-white;
  width: 100%;
  padding: 10px 15px;
  border: none;

  &:active {
    opacity: 0.7;
  }
}
.loading {
  opacity: 0.7;
  pointer-events: none;
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.secondary {
  background: transparent;
  color: $pj-color-green;
}
</style>
